import { useController } from '../hooks/useController'
import { DeleteOrders } from './DeleteOrders'
import { EditPlanningRange } from './EditPlanningRange'
import { ExportOrders } from './ExportOrders/ExportOrders'

export function Body() {
  const {
    data: { model },
  } = useController()

  const renderContent = () => {
    switch (model) {
      case 'export':
        return <ExportOrders />

      case 'planningRange':
        return <EditPlanningRange />

      case 'delete':
        return <DeleteOrders />

      default:
        return null
    }
  }

  return <>{renderContent()}</>
}
